import billingSaga from './modules/billing/sagas'
import customerSaga from './modules/customer/sagas'
import emptySimsSaga from './modules/emptySims/sagas'
import forgotPasswordSaga from './modules/forgotPassword/sagas'
import globalSaga from './modules/global/sagas'
import simCardsSaga from './modules/simCards/sagas'
import simsSaga from './modules/sims/sagas'
import usageSaga from './modules/usage/sagas'

const sagas = [
	billingSaga,
	customerSaga,
	emptySimsSaga,
	forgotPasswordSaga,
	globalSaga,
	simCardsSaga,
	simsSaga,
	usageSaga
  ];

export const runSagas = (sagaMiddleware) => sagas.forEach(s => sagaMiddleware.run(s[0]));
